import React, { useEffect, useState } from "react";
import "./Feed.css";

import { FetchingAdmins } from "../../../Redux/Actions/AdminActions/FetchingAdmins";
import EventsCarousel from "../EventsCarousel/EventsCarousel";
import { FetchingLatestUpdatedEvents } from "../../../Redux/Actions/EventsActions/FetchingLatestUpdatedEvents";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import DataBox from "../DataBox/DataBox";
import { useAppSelector, useAppThunkDispatch } from "../../../Redux/hooks";
import { Route, Routes } from "react-router-dom";
import MasjidTable from "../../PageComponents/MasjidTable/MasjidTable";
import { useQuery } from "@apollo/client";
import { GET_MASJIDS_COUNT } from "../../../graphql/queries";

// import { useAppSelector, useAppThunkDispatch } from "../../../Redux/hooks";

export type AdminInterFace = {
  autoPrefillingTiming: boolean;
  email: string;
  isVerified: boolean;
  masjids: any[];
  name: string;
  role: string;
  _id: string;
};
const Feed = () => {
  // const masjids = useAppSelector((state) => state.masjids);
  const admins = useAppSelector((state) => state.allAdmins);
  // const staleMasjids = useAppSelector((state) => state.staleMasjids);
  const [Loading, setLoading] = useState(false);
  const dispatch = useAppThunkDispatch();
  // const admin = JSON.parse(localStorage.getItem("admin"));
  const { data: countData, loading } = useQuery(GET_MASJIDS_COUNT, {
    fetchPolicy: "network-only",
  });

  const adminString = localStorage.getItem("admin");
  const admin: AdminInterFace | null = adminString
    ? JSON.parse(adminString)
    : null;

  useEffect(() => {
    if (admin?.role === "superadmin" || admin?.role === "admin") {
      setLoading(true);
      // console.log("masjids", masjids);

      admins.length === 0 && dispatch(FetchingAdmins());
      let res = dispatch(FetchingLatestUpdatedEvents());
      res.then((result: any) => {
        if (result.status === 200) {
          setLoading(false);
        }
      });
      // staleMasjids.length === 0 &&
    }
  }, []);

  return (
    <div className="FeedCenterContainer">
      {
        <>
          <div className="FeedUpperSection">
            <div className="FeedNumberData">
              <DataBox
                name={"Masjid"}
                isLoading={loading}
                length={countData?.totalMasjids ?? 0}
              />
              <DataBox data={admins} name={"Admins"} isLoading={Loading} />
            </div>
            {Loading ? (
              <>
                <div className="skeletonCarousel">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="SkeletonContainer">
                      <Stack spacing={1}>
                        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton
                          variant="rectangular"
                          width={210}
                          height={60}
                        />
                        <Skeleton variant="rounded" width={210} height={60} />
                      </Stack>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="FeedEventsTable">
                  <EventsCarousel />
                </div>
              </>
            )}
          </div>
          <div className="FeedLowerSection">
            <div className="FeedMasjidTable">
              <MasjidTable />
            </div>
          </div>
        </>
      }
    </div>
  );
};

export default Feed;
